<template>
  <div class="toggle-button">
    <div class="button" :class="{ active: value === itemValue(item) }" @click="$emit('input', itemValue(item))" v-for="(item, ind) in items" :key="ind">
      {{ (item.text || item).toUpperCase() }}
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'items'],
  methods: {
    itemValue(item) {
      return item.value !== undefined ? item.value : item;
    },
  }
}
</script>

<style lang="scss" scoped>
.toggle-button {
  display: inline-block;
  border-radius: 3px;
  width: fit-content;
  box-shadow: 0 1px 4px 1px rgba(6, 10, 36, 0.1), 0 5px 10px 0 rgba(6, 10, 36, 0.08);
  white-space: nowrap;
  .button {
    display: inline-block;
    padding: 6px 16px;
    background-color: #ffffff;
    border-right: 1px solid #d2d2d4;
    cursor: pointer;
    &.active {
      background-color: #002f6c;
      color: #ffffff;
    }
  }
}
</style>